import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {FIELD_MANDATORY_ERROR} from '../../../../core/constants/validation-error-strings.constants';
import {ApiService} from '../../../../core/http/api.service';
import {catchError} from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import {throwError} from 'rxjs';
import {FORBIDDEN_403, NOT_VALID_422} from '../../../../core/constants/statuses.constants';

@Component({
  selector: 'app-verify-device',
  templateUrl: './verify-device.component.html',
  styleUrls: ['./verify-device.component.scss']
})
export class VerifyDeviceComponent implements OnInit {

  @Input() userId;
  @Output() deviceVerifyDone: EventEmitter<boolean> = new EventEmitter<boolean>();

  verifyDeviceForm: UntypedFormGroup;
  isLoadingDetails = false;
  formSubmitted = false;
  pinExpired = false;
  notValid = false;

  readonly FIELD_MANDATORY_ERROR = FIELD_MANDATORY_ERROR;

  get pin(): AbstractControl {
    return this.verifyDeviceForm.get('pin');
  }

  constructor(private formBuilder: UntypedFormBuilder,
              private api: ApiService) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  verifyDevice(): void {
    this.formSubmitted = true;
    this.verifyDeviceForm.markAllAsTouched();
    if (this.verifyDeviceForm.valid) {
      this.isLoadingDetails = true;
      this.api.Users.verifyUserDevice(this.userId, {
        // tslint:disable-next-line:radix
        verifyPin: parseInt(this.pin.value)
      }).pipe(catchError((error: HttpErrorResponse) => {
        this.isLoadingDetails = false;
        if (error.status === FORBIDDEN_403) {
          this.pinExpired = true;
        } else if (error.status === NOT_VALID_422) {
          this.notValid = true;
        }
        return throwError(error);
      }))
        .subscribe(() => {
          this.deviceVerifyDone.emit(true);
        }, (error) => {
          console.error(error);
        });
    }
  }

  private createForm(): void {
    this.verifyDeviceForm = this.formBuilder.group({
      pin: ['', [Validators.required]]
    });
  }

}
